// src/utils/cx.ts
function isValidClassName(className) {
  if (/^[0-9]/.test(className))
    return false;
  if (/^-\d/.test(className))
    return false;
  return true;
}
function cx(...classNames) {
  const result = [];
  for (const className of classNames) {
    if (!className)
      continue;
    switch (typeof className) {
      case "object":
        let classStr = "";
        if (Array.isArray(className)) {
          result.push(
            className.map((v) => {
              return cx(v);
            }).join(" ")
          );
          continue;
        }
        Object.keys(className).forEach((key) => {
          if (className[key])
            classStr += key + " ";
        });
        result.push(classStr.trim());
        continue;
      case "string":
        result.push(className);
        continue;
      default:
        continue;
    }
  }
  return result.filter(Boolean).join(" ");
}

export {
  isValidClassName,
  cx
};
